const emailHtmlTemplate = `
<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <title>Votre colis est en route</title>
</head>
<body style="font-family: Arial, sans-serif; background-color: #f9f9f9; padding: 0; margin: 0;">
  <table align="center" width="auto" cellpadding="0" cellspacing="0" style="background-color: #ffffff; border-collapse: collapse; margin: 20px auto; box-shadow: 0 0 5px rgba(0,0,0,0.1);">
    <tr>
      <td style="padding: 0;">
        <img src="https://danielli.amira.jewelry/media/email_bg.jpg" alt="Bague" width="100%" style="display: block;">
      </td>
    </tr>
    <tr>
      <td style="background-color: #a97c6c; color: white; text-align: center; padding: 10px 0; font-size: 18px; font-weight: bold;">
        Votre colis est en route !
      </td>
    </tr>
    <tr>
      <td style="padding: 20px; color: #333333; font-size: 14px; line-height: 1.6;">
        <p>Bonjour,</p>
        <p>Bonne nouvelle, nous avons un colis pour vous.</p>
        <p>Il contient les éléments suivants:</p>

        {{PACKAGE_LIST}}

        <p>
          Votre colis quitte notre entrepôt ce jour, et sera pris en charge par le réseau FEDEX.
        </p>

        <div style="text-align: center; margin: 30px 0;">
          <a href="https://www.fedex.com/fedextrack/?trknbr={{TRAKING_NUMBER}}" target="_blank" style="background-color: #f28c3a; color: white; text-decoration: none; padding: 12px 25px; border-radius: 4px; font-size: 16px; display: inline-block; border: 2px solid #e0552d;">Suivre mon colis</a>
        </div>

        <p>L’équipe Danielli Collection vous remercie pour votre confiance.</p>
      </td>
    </tr>
  </table>
</body>
</html>
`;

export default emailHtmlTemplate;
